<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
    <!-- 页面头部 -->
    <div class="flex items-center gap-4 mb-6">
      <button
        @click="handleBack"
        class="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
      >
        <ArrowLeftIcon class="w-6 h-6" />
      </button>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">创建公告</h1>
    </div>

    <!-- 表单 -->
    <AnnouncementForm @submit="handleSubmit" @cancel="handleBack" />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'
import AnnouncementForm from '@/components/announcement/AnnouncementForm.vue'
import { createAnnouncementAPI } from '@/api/announcement'
import toaster from '@/utils/toaster'
import type { CreateAnnouncementRequest } from '@/types/announcement'

/**
 * 路由实例
 */
const router = useRouter()

/**
 * 返回列表页
 */
const handleBack = () => {
  router.push('/announcement')
}

/**
 * 处理表单提交
 */
const handleSubmit = async (data: CreateAnnouncementRequest) => {
  try {
    const response = await createAnnouncementAPI(data)

    if (response.status === 200 || response.status === 'success') {
      toaster.success('公告创建成功')
      router.push('/announcement')
    } else {
      toaster.error(response.message || '公告创建失败')
    }
  } catch (error: any) {
    console.error('创建公告失败:', error)
    toaster.error(error.message || '公告创建失败,请稍后重试')
  }
}
</script>

